import Reveal from "@/components/Reveal";
import { Bot, MessageSquare, Mic, RefreshCw, FileSpreadsheet, Repeat } from "lucide-react";

const SERVICES = [
  { icon: MessageSquare, t: "Chatbots para redes", d: "Responden, cualifican y derivan 24/7." },
  { icon: Repeat, t: "Respuestas a preguntas frecuentes", d: "Las dudas de siempre, resueltas sin escribir lo mismo cien veces." },
  { icon: RefreshCw, t: "Seguimiento automático de interesados", d: "Nadie se queda olvidado en el buzón." },
  { icon: Mic, t: "Agentes de voz", d: "Llamadas para confirmar, recordar o cualificar." },
  { icon: Bot, t: "Recuperación de contactos antiguos", d: "Reactivamos tu base dormida con secuencias automáticas." },
  { icon: FileSpreadsheet, t: "Formularios y flujos de cualificación", d: "Los interesados se ordenan solos por nivel de intención." },
];

export default function Automation() {
  return (
    <section id="automatizacion" data-testid="automation-section" className="relative py-24 lg:py-32 border-t border-white/5">
      <div className="absolute inset-0 bg-gradient-to-b from-[#050505] via-[#0a0a0a] to-[#050505]" />
      <div className="max-w-7xl mx-auto px-4 md:px-8 relative">
        <Reveal>
          <div className="font-stencil text-xs text-[#00A0A0] tracking-widest mb-4">04 / EL SISTEMA POR DENTRO</div>
          <h2 className="font-heading text-white text-4xl sm:text-5xl lg:text-6xl xl:text-7xl uppercase tracking-tight leading-[0.95] max-w-5xl">
            TU NEGOCIO NO DEBERÍA
            <br />
            <span className="text-white/40">DEPENDER DE RESPONDER</span>
            <br />
            <span className="font-stencil text-[#00A0A0]">MENSAJES TODO EL DÍA.</span>
          </h2>
        </Reveal>

        <Reveal delay={150}>
          <p className="mt-10 text-lg lg:text-xl text-white/70 max-w-3xl leading-relaxed font-body">
            Mientras tú cierras ventas, el sistema <span className="text-white">responde</span>,{" "}
            <span className="text-white">ordena</span> y hace <span className="text-white">seguimiento</span>.
            Para que ninguna oportunidad se pierda por falta de tiempo.
          </p>
        </Reveal>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {SERVICES.map((s, i) => (
            <Reveal key={s.t} delay={i * 70}>
              <div data-testid={`auto-${i}`} className="group h-full bg-[#0a0a0a] p-7 lg:p-8 hover:bg-[#0f0f0f] transition-colors duration-500 relative">
                <div className="w-11 h-11 border border-[#FFD700]/30 bg-[#FFD700]/5 flex items-center justify-center mb-5 group-hover:border-[#FFD700]/60 transition-colors">
                  <s.icon className="w-5 h-5 text-[#FFD700]" strokeWidth={1.75} />
                </div>
                <h3 className="font-stencil text-base lg:text-lg text-white uppercase tracking-wide mb-2">{s.t}</h3>
                <p className="text-sm text-white/55 leading-relaxed font-body">{s.d}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={300}>
          <div className="mt-14 text-center">
            <div className="inline-block px-8 py-5 border-y-2 border-[#FFD700]">
              <p className="font-stencil text-xl sm:text-2xl lg:text-3xl text-white uppercase tracking-tight">
                <span className="text-white/55">Menos tareas repetitivas.</span>{" "}
                <span className="text-[#FFD700]">Más conversaciones que valen la pena.</span>
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
